import React, { useEffect, useState } from "react";
import HashLoader from "react-spinners/HashLoader";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";
import * as qrcode from "qrcode";
import getAppCountry from "../utils/getAppCountry";

export default function DeeplinkRedirectPage() {
	const location = useLocation();
	const [code, setCode] = useState(null);

	function navigate(path) {
		window.location.replace(path);
	}

	const getToken = async () => {
		const deeplink = location.search.split("url=")[1];

		const countryCode = deeplink.split("://")[0].split(".")[0];
		// Determine the platform and set the appropriate deeplink
		let platformSpecificDeeplink;

		if (countryCode === "at") {
			platformSpecificDeeplink = isIOS() ? "at.taxefy.app" : "at.taxefy.app";
		} else if (countryCode === "de") {
			platformSpecificDeeplink = isIOS() ? "de.taxefy.app" : "de.taxefy.android";
		} else {
			// Fallback in case no country match
			platformSpecificDeeplink = deeplink;
		}

		const url = `${platformSpecificDeeplink}://${deeplink.split("://")[1]}`;

		if (!isMobile) {
			// Generate QR code for the deeplink if not mobile
			const temp = await qrcode.toDataURL(url);
			setCode(temp);
		} else {
			// Redirect mobile users directly
			navigate(url);
		}
	};

	// Helper function to detect iOS
	const isIOS = () => {
		return /iPhone|iPad|iPod/i.test(navigator.userAgent);
	};

	useEffect(() => {
		getToken();
	}, []);

	return (
		<div style={{ textAlign: "center", paddingTop: "20vh" }}>
			{isMobile && <HashLoader color="gray" size={55} />}
			{!isMobile && (
				<div>
					<h1 style={{ color: "rgba(0, 190, 170, 1)" }}>
						Weiter mit dem Handy - Scanne den QR Code
					</h1>
					<img src={code} style={{ margin: "20px", width: "20%" }} alt="QR Code" />
				</div>
			)}
		</div>
	);
}
